import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { dayOfWeekList, dayOfWeekName } from "../../../util/DateUtil";
import { REFEICOES, SEMANAS } from "./cardapioSemanaUtil";

const MAX = 300;

/** Diálogo com as três refeições de um dia do cardápio. */
const CardapioSemanaForm = ({ cardapioSemana, onClose, onSave, onRemove, isSaving }) => {
  const [form, setForm] = useState(null);

  useEffect(() => {
    setForm(cardapioSemana ? { ...cardapioSemana } : null);
  }, [cardapioSemana]);

  const set = (campo, valor) => setForm((prevState) => ({ ...prevState, [campo]: valor }));
  const eNovo = !form?.codigo;
  const podeSalvar =
    form &&
    form.numeroSemana !== undefined &&
    form.diaSemana !== undefined &&
    REFEICOES.every(({ campo }) => (form[campo] ?? "").trim() !== "") &&
    !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave(form);
  };

  return (
    <Dialog open={Boolean(cardapioSemana)} onClose={onClose} fullWidth maxWidth="sm">
      {form && (
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            {dayOfWeekName(Number(form.diaSemana))} · {form.numeroSemana}ª Semana
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} pt={1}>
              <Grid container spacing={2}>
                <Grid size={6}>
                  <TextField
                    select
                    size="small"
                    fullWidth
                    required
                    label="Semana"
                    value={form.numeroSemana ?? ""}
                    onChange={(event) => set("numeroSemana", event.target.value)}
                  >
                    {SEMANAS.map((n) => (
                      <MenuItem key={n} value={n}>
                        {n}ª Semana
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid size={6}>
                  <TextField
                    select
                    size="small"
                    fullWidth
                    required
                    label="Dia da semana"
                    value={form.diaSemana ?? ""}
                    onChange={(event) => set("diaSemana", event.target.value)}
                  >
                    {dayOfWeekList.map((dow) => (
                      <MenuItem key={dow.value} value={dow.value}>
                        {dow.description}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              {REFEICOES.map(({ campo, label }) => (
                <TextField
                  key={campo}
                  size="small"
                  fullWidth
                  required
                  multiline
                  minRows={3}
                  label={label}
                  value={form[campo] ?? ""}
                  onChange={(event) => set(campo, event.target.value)}
                  helperText={`${(form[campo] ?? "").length}/${MAX}`}
                  slotProps={{ htmlInput: { maxLength: MAX } }}
                />
              ))}
            </Stack>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
            <Box>
              {!eNovo && (
                <Button color="error" startIcon={<DeleteOutlineIcon />} disabled={isSaving} onClick={() => onRemove(form)}>
                  Remover
                </Button>
              )}
            </Box>
            <Stack direction="row" spacing={1}>
              <Button onClick={onClose}>Cancelar</Button>
              <Button type="submit" variant="contained" disabled={!podeSalvar}>
                Salvar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      )}
    </Dialog>
  );
};

export default CardapioSemanaForm;
